export default __webpack_public_path__ + "static/media/Group 1715@2x.f2000a99.png";